<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">{{ header }}</div>
    <div class="sopo-popup-text">{{ body }}</div>

    <div class="sopo-popup-input-container" [ngClass]="{ 'submitted': submitted }">

        <div class="field-container">
            <div class="field-wrapper">
                <div class="field-label">First name</div>
                <input
                    class="sopo-popup-input"
                    [(ngModel)]="form.firstName"
                    [disabled]="!isEditable"
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>
            <div class="field-wrapper">
                <div class="field-label">Middle name</div>
                <input
                    class="sopo-popup-input"
                    [(ngModel)]="form.middleName"
                    [disabled]="!isEditable"
                />
            </div>
            <div class="field-wrapper">
                <div class="field-label">Last Name</div>
                <input
                    class="sopo-popup-input"
                    [(ngModel)]="form.lastName"
                    [disabled]="!isEditable"
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>
        </div>
        
        <div class="field-wrapper">
            <div class="field-label">Address Line 1</div>
            <input
                class="sopo-popup-input" 
                [(ngModel)]="form.addressLine1"
                [disabled]="!isEditable"
                required
                (ngModelChange)="validateForm()"
            />
        </div>

        <div class="field-wrapper">
            <div class="field-label">Address Line 2</div>
            <input 
                class="sopo-popup-input"
                [(ngModel)]="form.addressLine2"
                [disabled]="!isEditable"
            />
        </div>

        <div class="field-container">
            <div class="field-wrapper" style="flex: 4;">
                <div class="field-label">City</div>
                <input
                    class="sopo-popup-input"
                    [(ngModel)]="form.city"
                    [disabled]="!isEditable"
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>

            <div class="field-wrapper" style="flex: 1.5;">
                <div class="field-label">State</div>
                <input
                    class="sopo-popup-input"
                    [(ngModel)]="form.state"
                    [disabled]="!isEditable"
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>

            <div class="field-wrapper" style="flex: 2;">
                <div class="field-label">ZIP</div>
                <input
                    class="sopo-popup-input"
                    type="text"
                    [(ngModel)]="form.zip"
                    [disabled]="!isEditable"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>
        </div>

        <div class="field-container">
            <div class="field-wrapper" style="flex: 1;">
                <div class="field-label">Country</div>
                <select
                    class="sopo-popup-input"
                    [(ngModel)]="form.country"
                    [disabled]="!isEditable"
                    required
                    (ngModelChange)="validateForm()"
                >
                    <option *ngFor="let country of countryList" [value]="country.code">
                        {{ country.name }}
                    </option>
                </select>
            </div>

            <div class="field-wrapper" style="flex: 1;">
                <div class="field-label">Birth Date</div>
                <ion-datetime-button class="date-time" datetime="birthDatePicker" [class.disabled]="!isEditable"></ion-datetime-button>
    
                <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                        <ion-datetime
                            [showDefaultButtons]="true"
                            color="medium"
                            id="birthDatePicker"
                            [(ngModel)]="form.birthDate"
                            presentation="date"
                            [disabled]="!isEditable"
                            [formatOptions]="{
                                date: {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }
                            }"
                            required
                            (ngModelChange)="validateForm()"
                        >
                        </ion-datetime>
                    </ng-template>
                
                </ion-modal>
            </div>
        </div>

        <div class="field-container">
            <div class="field-wrapper" style="flex: 1;">
                <div class="field-label">Phone</div>
                <input
                    class="sopo-popup-input"
                    [value]="form.phone"
                    disabled
                    required
                    (ngModelChange)="validateForm()"
                />
            </div>
    
            <div class="field-wrapper" style="flex: 1;">
                <div class="field-label">SSN</div>
            <input
                *ngIf="!isEditable"
                class="sopo-popup-input"
                [value]="getMaskedSSN(form.ssn)"
                disabled
                required
                (ngModelChange)="validateForm()"
            />

            <input
                *ngIf="isEditable"
                class="sopo-popup-input"
                type="text"
                [(ngModel)]="form.ssn"
                inputmode="numeric"
                pattern="^\d{9}$"
                maxlength="9"
                required
                (ngModelChange)="validateForm()"
            />
            </div>
        </div>
    </div>

    <div *ngIf="ageError" class="form-error-message">
        You must be at least 18 years old.
    </div>
    <div *ngIf="missingFieldsError" class="form-error-message">
        Please fill in all required fields.
    </div>
    <div *ngIf="ssnError" class="form-error-message">
        SSN must be exactly 9 digits.
    </div>

    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="confirm()">
            CONFIRM
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-yellow-button ion-activatable clickable" *ngIf="!isEditable" (click)="incorrectInfo()">
            EDIT
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-red-button ion-activatable clickable" (click)="cancel()">
            CANCEL
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>